<template>
    <div>
        <question-form  
            :is-question-form-sidebar-active.sync="isQuestionFormSidebarActive"
            :question-data="questionData" 
            :lang-data="langs"
            @refetch-data="refetchData"  
        />
        <b-button variant="primary" style="margin-bottom: 20px;" @click="addQuestion({})">
            <span class="text-nowrap">+ Add FAQ</span>
        </b-button>

        <draggable
            v-model="faqData"
            handle=".handle"
            item-key="id"
            @end="updateOrdering"
        >
            <div
                class="draggable-item d-flex align-items-center justify-content-between p-3 border rounded col-12 mb-2"
                style="min-height: 100px;"
                v-for="(itm, index) in faqData" 
                :key="'repeat-' + index"
            >
                <MenuIcon icon="MenuIcon" class="handle mr-3 mt-1" />
                <div class="row flex-grow-1">
                    <div class="col-6 pr-3">
                        <p class="mb-1 font-weight-bold">Question:</p>
                        <div v-html="itm.question[currentLocale]"></div>
                    </div>
                    <div class="col-6 pl-3">
                        <p class="mb-1 font-weight-bold">Answer:</p>
                        <div v-html="itm.answer[currentLocale]"></div>
                    </div>
                </div>

                <div class="d-flex align-items-center">
                    <b-button
                        variant="warning"
                        size="sm"
                        class="mr-2"
                        @click="addQuestion(itm)"
                    >
                        Edit
                    </b-button>
                    <b-button
                        variant="danger"
                        size="sm"
                        @click="deleteFAQ(itm)"
                    >
                        Delete
                    </b-button>
                </div>
            </div>
        </draggable>
    </div>
</template>

<script>
import {
    BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormTextarea, BFormRating,BFormCheckbox,BFormCheckboxGroup,
    BTab, BTabs, BInputGroup, BBadge, BCard,
} from 'bootstrap-vue'
import { ref, nextTick, onUnmounted } from '@vue/composition-api'
import {  MenuIcon } from 'vue-feather-icons'
import store from '@/store'
import router from '@/router'
import languagesStoreModule from '../../languages/languagesStoreModule'
import propertypinsStoreModule from '../propertypinsStoreModule'
import QuestionForm from './questionForm.vue';
import draggable from 'vuedraggable'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'

export default {
    components: {
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
        BFormTextarea,
        BFormRating,
        BFormCheckbox,
        BFormCheckboxGroup,
        BTab, 
        BTabs,
        BInputGroup,
        BBadge,
        BCard,
        QuestionForm,
        draggable,
        BCardActions,
        MenuIcon,
    },
    directives: {
        Ripple,
    },
    computed: {
        currentLocale() {
            return  this.$i18n.locale;
        },
    },
    setup() {
        const LANGUAGES_STORE_MODULE_NAME = 'app-languages';
        if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule)
    
        const PLACE_STORE_MODULE_NAME = 'app-place';
        if (!store.hasModule(PLACE_STORE_MODULE_NAME)) store.registerModule(PLACE_STORE_MODULE_NAME, propertypinsStoreModule)

        onUnmounted(() => {
            if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME)
            if (store.hasModule(PLACE_STORE_MODULE_NAME)) store.unregisterModule(PLACE_STORE_MODULE_NAME)
        });

        const toast = useToast()
        const isQuestionFormSidebarActive = ref(false);
        const questionData = ref({})
        const langs = ref([])
        const faqData = ref([])
        const place_id = ref(router.currentRoute.params.id);

        const refetchData = async() =>{
            const response = await store.dispatch('app-place/fetchFAQs', { place_id: place_id.value, order_by: 'ORDERING_COUNT ASC' })

            if (response.data.success) {
                faqData.value = response?.data?.data
            } else {
                toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Error',
                        icon: 'BellIcon',
                        variant: 'danger',
                        text: response.data.message,
                    },
                })
            }
        }

        const addQuestion = (data) => {
            if (!data) {
                data = {};
            }

            questionData.value = data;
            isQuestionFormSidebarActive.value = false;
            nextTick(() => {
                isQuestionFormSidebarActive.value = true;
            });
        }

        const getFAQList = () => {
            faqData.value = []
            store.dispatch('app-place/fetchFAQs', { order_by: 'ORDERING_COUNT ASC', "place_id": place_id.value })
                .then((res) => {
                    if(res.data.success){
                        faqData.value = res?.data?.data;
                    }
            });
        }

        const getLangs = () => {
            store.dispatch('app-languages/fetchData', { is_active: 1 })
                .then((res) => {
                    if(res.data.success){
                        langs.value = res?.data?.data;
                    }
            });
        }

        const updateOrdering = async () => {
            const response = await store.dispatch('app-place/updateOrderingFAQ', faqData.value)

            if (!response.data.success) {
                toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Error',
                        icon: 'BellIcon',
                        variant: 'danger',
                        text: response.data.message,
                    },
                })
            }
        }

        getLangs()
        getFAQList()
        refetchData()

        return {
            isQuestionFormSidebarActive,
            questionData,
            langs,
            refetchData,
            addQuestion,
            faqData,
            updateOrdering,
        }
    },
    methods: {
        async deleteFAQ(item) {
            try {
                const confirmed = await this.$bvModal.msgBoxConfirm(
                    `Please confirm that you want to delete "${item.question[this.currentLocale]}"?`,
                    {
                        title: 'Please Confirm',
                        size: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        cancelVariant: 'outline-secondary',
                        hideHeaderClose: false,
                        centered: true,
                    }
                );

                if (!confirmed) return;

                const response = await this.$store.dispatch('app-place/deleteFAQ', item.id);

                if (response.data.success) {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: 'Success',
                            icon: 'BellIcon',
                            variant: 'success',
                            text: response.data.message,
                        },
                    });

                    this.refetchData();
                } else {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: 'Error',
                            icon: 'BellIcon',
                            variant: 'danger',
                            text: response.data.message || 'Failed to delete the FAQ.',
                        },
                    });
                }
            } catch (error) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Error',
                        icon: 'BellIcon',
                        variant: 'danger',
                        text: error.response?.data?.message || 'There was a problem deleting the FAQ.',
                    },
                });
            }
        }
    }
}
</script>